/* ============================================================
   SOCIAL YIELD — theme.js
   Lenis + GSAP wiring, nav, reveals, counters, accordion,
   metric counters, marquee.
   ============================================================ */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll (armed only when we can guarantee reveal) ---------- */
  try {
    if ('IntersectionObserver' in window && !reduced) {
      var revealed = document.querySelectorAll('.rv');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in-view'); io.unobserve(en.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      revealed.forEach(function (el) { io.observe(el); });
      document.documentElement.classList.add('rv-armed');
    }
  } catch (e) { /* content stays visible */ }

  /* ---------- Lenis smooth scroll ---------- */
  try {
  if (!reduced && window.Lenis) {
    var lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    if (window.gsap && window.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      (function raf(time) { lenis.raf(time); requestAnimationFrame(raf); })(0);
    }
  }
  } catch (e) { /* smooth scroll optional */ }

  /* ---------- Header state ---------- */
  var header = document.querySelector('.site-header');
  function onScrollHeader() {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 24);
  }
  window.addEventListener('scroll', onScrollHeader, { passive: true });
  onScrollHeader();

  /* ---------- Mobile menu ---------- */
  var toggle = document.querySelector('.nav-toggle');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = document.documentElement.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (window.__lenis) { open ? window.__lenis.stop() : window.__lenis.start(); }
    });
    document.querySelectorAll('.nav-overlay a').forEach(function (a) {
      a.addEventListener('click', function () {
        document.documentElement.classList.remove('nav-open');
        if (window.__lenis) window.__lenis.start();
      });
    });
  }
  /* stagger the overlay links */
  document.querySelectorAll('.nav-overlay a.nav-big').forEach(function (a, idx) {
    a.style.transitionDelay = (0.06 + idx * 0.05) + 's';
  });



  /* ---------- Metric counters ---------- */
  function animateCount(el) {
    var raw = el.getAttribute('data-count') || '0';
    var dec = (raw.split('.')[1] || '').length;
    var end = parseFloat(raw.replace(/,/g, '')) || 0;
    var dur = 1600, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur);
      k = 1 - Math.pow(1 - k, 3);
      var val = end * k;
      el.textContent = dec ? val.toFixed(dec) : Math.round(val).toLocaleString('en-US');
      if (k < 1) requestAnimationFrame(step);
    }
    if (reduced) { el.textContent = dec ? end.toFixed(dec) : end.toLocaleString('en-US'); return; }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll('[data-count]');
  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { animateCount(en.target); cio.unobserve(en.target); }
      });
    }, { threshold: 0.5 });
    counters.forEach(function (el) { cio.observe(el); });
  } else {
    counters.forEach(animateCount);
  }

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('.faq__item').forEach(function (item) {
    var q = item.querySelector('.faq__q');
    var a = item.querySelector('.faq__a');
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      var parent = item.closest('.faq');
      if (parent) parent.querySelectorAll('.faq__item.is-open').forEach(function (o) {
        o.classList.remove('is-open');
        o.querySelector('.faq__a').style.maxHeight = '0px';
        o.querySelector('.faq__q').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        a.style.maxHeight = a.scrollHeight + 'px';
        q.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---------- Feature card cursor glow ---------- */
  document.querySelectorAll('.fcard').forEach(function (card) {
    card.addEventListener('pointermove', function (e) {
      var r = card.getBoundingClientRect();
      card.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
      card.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100) + '%');
    });
  });

  /* ---------- Marquee: duplicate row for seamless loop ---------- */
  document.querySelectorAll('.marquee__row').forEach(function (row) {
    row.innerHTML += row.innerHTML;
  });
})();
